import { render } from "./ItemCardLarge.vue?vue&type=template&id=638d8d82&scoped=true"
import script from "./ItemCardLarge.vue?vue&type=script&lang=js"
export * from "./ItemCardLarge.vue?vue&type=script&lang=js"

import "./ItemCardLarge.vue?vue&type=style&index=0&id=638d8d82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638d8d82"]])

export default __exports__